import { BasicContainer } from '@/components/Common/BasicContainer/BasicContainer';
import FormItem from '@/components/Common/FormItem/FormItem';
import { FormSectionTitle } from '@/components/Form/FormSectionTitle/FormSectionTitle';
import { Button, FormControl, Grid, OutlinedInput, Stack } from '@mui/material';
import { useSellerAddressViewController } from './SellerAddressViewController';

export function SellerAddressData() {
  const { uiState, actions } = useSellerAddressViewController();

  return (
    <Stack
      spacing={'12px'}
      mt={{ xs: '20px', md: '40px' }}
      p={{ xs: '16px', md: '0px' }}
    >
      <FormSectionTitle title={'Dirección del negocio'} />
      <BasicContainer
        content={
          <Grid container columnSpacing={'20px'} p={'16px'}>
            <Grid item xs={12}>
              <FormItem label="Calle" helperText={uiState.streetError}>
                <OutlinedInput
                  fullWidth
                  value={uiState.street}
                  onChange={(e) => actions.onChangedStreet(e.target.value)}
                  error={!!uiState.streetError}
                />
              </FormItem>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormItem
                label="Número exterior"
                helperText={uiState.exteriorNumberError}
              >
                <OutlinedInput
                  fullWidth
                  value={uiState.exteriorNumber}
                  onChange={(e) =>
                    actions.onChangedExteriorNumber(e.target.value)
                  }
                  error={!!uiState.exteriorNumberError}
                />
              </FormItem>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormItem
                label="Número interior (opcional)"
                helperText={uiState.interiorNumberError}
              >
                <OutlinedInput
                  fullWidth
                  value={uiState.interiorNumber}
                  onChange={(e) =>
                    actions.onChangedInteriorNumber(e.target.value)
                  }
                  error={!!uiState.interiorNumberError}
                />
              </FormItem>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <FormItem
                  label="Código Postal"
                  helperText={uiState.postalCodeError}
                >
                  <OutlinedInput
                    fullWidth
                    value={uiState.postalCode}
                    onChange={(e) =>
                      actions.onChangedPostalCode(e.target.value)
                    }
                    error={!!uiState.postalCodeError}
                  />
                </FormItem>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormItem label="Colonia" helperText={uiState.coloniaError}>
                <OutlinedInput
                  fullWidth
                  value={uiState.colonia}
                  onChange={(e) => actions.onChangedColonia(e.target.value)}
                  error={!!uiState.coloniaError}
                />
              </FormItem>
            </Grid>
          </Grid>
        }
        footer={
          <Stack sx={{ flexDirection: 'row-reverse', p: '16px' }} gap={'16px'}>
            <Button
              variant="contained"
              disabled={uiState.saveDisabled}
              onClick={actions.onClickedSave}
            >
              Guardar
            </Button>
            <Button
              variant="contained"
              disabled={uiState.cancelDisabled}
              onClick={actions.onClickedCancel}
            >
              Cancelar
            </Button>
          </Stack>
        }
      />
    </Stack>
  );
}
